import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import HeaderDeskop from './HeaderDeskop'

const LogoComponent = ({toggle,setToggle}) => {

  return (
    <div className='  overflow-hidden flex items-start justify-between  px-[3%]   z-50 sticky md:relative top-0 bg-white py-5'>
        <Link to={'/'} className='hidden md:block'><img src='/images/mini-logo.svg' className='h-6 md:h-16 '/></Link>





        <div className=' w-full  hidden md:block pt-6'>
          <HeaderDeskop/>
        </div>

      <div className='space-x-5 flex'>
        <Link to={'/'}><img src='/images/tmt.svg' className='h-10 md:h-16 '/></Link>
        <Link to={'/'}><img src='/images/logo.svg' className='h-10 md:h-16 '/></Link>
        </div>


        <div onClick={()=>setToggle(!toggle)} className='h-8 w-8  md:hidden relative flex flex-col justify-between cursor-pointer '>
              <div className={`h-0.5 w-8 bg-turkuaz-blue absolute transition-all duration-300  ${toggle?'top-3.5 rotate-45':'top-0 rotate-0'}`}></div>
              <div className={`h-0.5 w-8 bg-turkuaz-blue absolute transition-all duration-300  ${toggle?'top-3.5 rotate-0 translate-x-96':'top-3.5 rotate-0 translate-x-0'}`}></div>
              <div className={`h-0.5 w-8 bg-turkuaz-blue absolute transition-all duration-300  ${toggle?'top-3.5 -rotate-45':'top-7 rotate-0'}`}></div>
        </div>


    </div>


  )
}

export default LogoComponent